import MenuItem from '@/core/components/MenuItem/MenuItem';

export default MenuItem;
